import { Component, Input } from '@angular/core';
import { makeTwoDecimalPointsNumberMask } from '@app/functions';
import { BaseForm } from '@forms/base.form';
import { TimeOffRequestDay } from '@models/time-off-v3/time-off-request-day.model';
import { TimeOffRequest } from '@models/time-off-v3/time-off-request.model';
import { WEEK_DAYS_SHORT_FORMAT } from '@time-off-v3/meta/time-off-meta';
import cloneDeep from 'lodash-es/cloneDeep';
import groupBy from 'lodash-es/groupBy';

@Component({
    selector: 'app-request-days-form',
    templateUrl: './request-days.template.html',
    styleUrls: ['./request-days.style.scss'],
})
export class RequestDaysForm extends BaseForm {
    @Input() timeOffRequest = new TimeOffRequest();
    @Input() maxAmount = 0;
    weekDays: string[] = [];
    requestDaysGrouped: TimeOffRequestDay[][] = [];
    twoDecimalPointsNumberMask = makeTwoDecimalPointsNumberMask();

    constructor() {
        super();
        this.weekDays = WEEK_DAYS_SHORT_FORMAT;
    }

    get isValid(): boolean | null {
        if (this.form?.submitted) {
            return this.form.valid;
        }

        return true;
    }

    beforeShow(): void {
        this.requestDaysGrouped = Object.values(groupBy(cloneDeep(this.timeOffRequest.timeOffRequestDays), 'week'));
    }

    getDayRequest(requestDays: TimeOffRequestDay[], weekDayIndex: number): TimeOffRequestDay | undefined {
        return requestDays.find((requestDay) => requestDay.weekDay === weekDayIndex);
    }
}
